'use client';

import { LinkContext, type Routes } from '@lichtblick/link/helpers/link-context';
import type { FC, PropsWithChildren } from 'react';

export const LinkContextProvider: FC<PropsWithChildren & { routes: Routes }> = ({ children, routes }) => (
  <LinkContext.Provider value={routes}>{children}</LinkContext.Provider>
);
